import React from "react";
import PropTypes from "prop-types";
import { GridRow } from "arv-reactcomponents";
import NeftBlock from "../NeftBlock";

const NeftList = props => {
  const { neftList, isButton, selectedNeftId, selectNeft } = props;

  function renderView() {
    if (neftList.length > 0) {
      return (
        <GridRow className="nw-neftlist-row nwc-custom-scrollbar">
          {neftList.map(neft => (
            <NeftBlock.component
              key={neft.id}
              neft={neft}
              isButton={isButton}
              isSelected={neft.id === selectedNeftId}
              selectNeft={selectNeft}
            />
          ))}
        </GridRow>
      );
    }
    return null;
  }

  return renderView();
};

NeftList.defaultProps = {
  neftList: [],
  isButton: false,
  selectedNeftId: "",
  selectNeft: PropTypes.func,
};

NeftList.propTypes = {
  neftList: PropTypes.shape({}),
  isButton: PropTypes.bool.isRequired,
  selectedNeftId: PropTypes.string,
  selectNeft: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: NeftList,
  component: NeftList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/NeftList/index.js